import { render, staticRenderFns } from "./PriorityVetting.vue?vue&type=template&id=da5b65fc&scoped=true"
import script from "./PriorityVetting.vue?vue&type=script&lang=js"
export * from "./PriorityVetting.vue?vue&type=script&lang=js"
import style0 from "./PriorityVetting.vue?vue&type=style&index=0&id=da5b65fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5b65fc",
  null
  
)

export default component.exports